import React from 'react';
import styled from 'styled-components';
import { EyeClosedIcon, EyeOpenIcon } from '@lt/components/icons-react/auth';
import type { IInput } from '@lt/components/components/Form/components/Input/types';
import {
  getPasswordValidateMessage,
  MAX_PASSWORD_LENGTH,
} from 'src/components/AuthNew/utils/validations';
import { Input } from './Input';

type Props = IInput & {
  isSecure?: boolean;
  maxLength?: number;
};

export const PasswordInput: React.FC<Props> = ({
  isSecure = true,
  maxLength,
  ...rest
}) => (
  <StyledInput
    data-sentry-mask
    nativeInputProps={{
      maxLength,
    }}
    type={isSecure ? 'password' : 'text'}
    showSuccessIcon={false}
    postfixIcon={
      isSecure ? (
        <EyeClosedIcon width={25} height={25} />
      ) : (
        <EyeOpenIcon width={25} height={25} />
      )
    }
    validate={getPasswordValidateMessage}
    maxLength={MAX_PASSWORD_LENGTH + 1}
    {...rest}
  />
);

const StyledInput = styled(Input)`
  &:-webkit-autofill {
    box-shadow: none !important;
  }
`;
